import React from 'react';

// Carta ao colega depois do escore: ponte contextual e não promocional para a conduta do PCDT de Alzheimer.
// Texto renderizado no prerender (indexável); nenhum valor de escore vai para a URL.
const UTM = 'utm_source=minimental&utm_medium=referral&utm_campaign=carta_douto&utm_content=meem_conduta';
export const DOUTO_CONDUTA_URL = `https://douto.app/situacao/alzheimer-adulto-tratamento/?${UTM}`;
export const DOUTO_CASO_URL = `https://douto.app/?${UTM.replace('meem_conduta', 'meem_caso')}`;

export default function DoutoConduta() {
  return (
    <section aria-labelledby="douto-conduta-title" className="max-w-[820px] mx-auto px-4 pb-12">
      <h2 id="douto-conduta-title" className="mb-4 border-b border-[var(--border-strong)] pb-3">Do escore à conduta</h2>
      <p className="mb-3 leading-relaxed">
        O Mini Mental organiza o rastreio; a conduta vem depois dele, e não depende só do número. O PCDT da Doença de Alzheimer
        (Portaria Conjunta SAES/SCTIE nº 27, de 27 de novembro de 2025) usa o <strong>MEEM e o CDR</strong> como critérios de
        inclusão por medicamento e traz o que usar em cada fase, as doses por via oral e o ajuste da memantina pela função renal.
      </p>
      <p className="mb-3 leading-relaxed">
        Organizei esse protocolo, trecho a trecho, com a fonte conferida:{' '}
        <a href={DOUTO_CONDUTA_URL} target="_blank" rel="noopener" className="font-semibold text-[var(--primary)] underline underline-offset-4">o que o PCDT de Alzheimer recomenda</a>.
        A página trata do adulto com doença de Alzheimer provável e dos medicamentos incorporados ao SUS. Os critérios de inclusão regem o
        acesso no SUS; a decisão de tratar é do médico assistente.
      </p>
      <p className="mb-3 leading-relaxed">
        Se o seu caso fugir do protocolo, você pode{' '}
        <a href={DOUTO_CASO_URL} target="_blank" rel="noopener" className="font-semibold text-[var(--primary)] underline underline-offset-4">descrever o paciente no Douto</a>,
        sem nome nem documento, e receber a conduta com a fonte ao lado. O primeiro caso é grátis.
      </p>
      <p className="text-sm text-[var(--text-muted)]">
        Dr. Carlos Felipe · CRM-MG 105.721. O MEEM não diagnostica Alzheimer isoladamente; esta informação não substitui o protocolo da sua instituição.
      </p>
    </section>
  );
}
